import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './SafeRentDescription.css';
import { trackSafeRentDescriptionShow, trackSafeRentDescriptionClick } from './tracking';

export interface ISafeRentDescriptionProps {
  id: number;
  openModal(): void;
}

const advIcon = require('./assets/adv.svg') as string;

const adv = [
  'Собственник предоставил нам документы о собственности',
  'Мы гарантируем актуальность объявления',
  'Никаких неудобных звонков — просто заполните анкету',
];

export const SafeRentDescription = ({ id, openModal }: ISafeRentDescriptionProps) => {
  /* istanbul ignore next */
  if (typeof window !== 'undefined') {
    trackSafeRentDescriptionShow(id);
  }

  return (
    <div id="safe-rent" className={styles['block']}>
      <div className={styles['title']}>
        Собственник сдаёт эту квартиру с Циан.
        <br />
        Что это значит?
      </div>

      <div className={styles['list']}>
        {adv.map((item: string) => (
          <div className={styles['list-item']}>
            <img src={advIcon} className={styles['list-icon']} />
            {item}
          </div>
        ))}
      </div>

      <Button
        custom={{ type: 'primary', mediaType: 'mobile' }}
        styles={{ width: '170px' }}
        onClick={() => {
          trackSafeRentDescriptionClick(id);
          openModal();
        }}
      >
        <span className={styles['button-text']}>Заполнить анкету</span>
      </Button>
    </div>
  );
};
